import { useQuery } from '@apollo/client';
import { Alert, AlertTitle, Typography } from '@mui/material';
import { isNotNil } from 'ramda';
import { useTranslation } from 'react-i18next';

import { TsrctSourcingCaseStatus } from '@/generated/gql/graphql';
import { Multiline } from '~/components/Multiline';

import { SOURCING_CASE_CANCELLED_ALERT_QUERY } from './SourcingCaseCancelledAlert.gql';

export const SourcingCaseCancelledAlert = ({ sourcingCaseId }: { sourcingCaseId: string }) => {
  const { t } = useTranslation();
  const { data } = useQuery(SOURCING_CASE_CANCELLED_ALERT_QUERY, {
    variables: { id: sourcingCaseId },
    skip: !sourcingCaseId,
  });

  const sourcingCase = data?.tesseract.sourcingCase;
  if (!sourcingCase || sourcingCase.status !== TsrctSourcingCaseStatus.CANCELLED) {
    return null;
  }

  const { cancellationReason, cancellationReasonText } = sourcingCase;

  const title = cancellationReason
    ? t('SourcingCaseDetail.cancelled.titleWithReason', {
        reason: t(`CaseCancellationReason.${cancellationReason}`),
      })
    : t('SourcingCaseDetail.cancelled.title');

  return (
    <Alert severity="info">
      <AlertTitle>{title}</AlertTitle>
      {isNotNil(cancellationReasonText) && cancellationReasonText !== '' && (
        <Typography variant="body2">
          <Multiline>{t('SourcingCaseDetail.cancelled.comment', { comment: cancellationReasonText })}</Multiline>
        </Typography>
      )}
    </Alert>
  );
};
